<template>
  <v-layout wrap justify-center>
    <v-flex xs9>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs9>
              <v-flex xs12 v-for="(title,key) in locationInfo" :key="key">
                <template v-if="title.value !== '-'">
                  <h3>{{ title.header }} {{ title.value }}</h3>
                </template>
              </v-flex>
            </v-flex>
            <v-flex pt-3 pr-2 xs3>
              <v-img :src="require('../assets/logo.png')" contain height="60px"></v-img>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
      <v-tabs v-model="activeTab" color="primary" dark background-color="primary">
        <v-tab v-for="(monthlyData, key) in location" :key="key">{{ monthlyData.periodName }}</v-tab>
        <v-tabs-items v-model="activeTab" touchless>
          <v-tab-item v-for="(monthlyData, key) in location" :key="key">
            <monthly-report
              :report-data="location[activeTab]"
              :last-month="lastMonth"
              :key="`${monthlyData.vendingMachineId}_${key}`"
            ></monthly-report>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-flex>
  </v-layout>
</template>

<script>
import MonthlyReport from '@/components/location/MonthlyReport'

export default {
  components: {
    MonthlyReport
  },

  data () {
    return {
      activeTab: 0,
      location: null
    }
  },

  computed: {
    monthlyData () {
      return this.location[this.activeTab]
    },

    locationInfo () {
      return [
        { header: `${this.$tc('location', 1)}:`, value: this.monthlyData.machineName },
        { header: `${this.$t('report.start_date')}:`, value: this.monthlyData['f p start date'] || '-' },
        { header: `${this.$t('report.guaranteed_period')}:`, value: this.$tc('month', this.monthlyData['G period month'], { value: this.monthlyData['G period month'] }) || '-' }
      ]
    },

    lastMonth () {
      return this.location[this.activeTab + 1] ? this.location[this.activeTab + 1].periodName : null
    }
  },

  watch: {
    location: function () {
      this.$store.commit('SET_CURRENT_LOCATION_DATA', this.location)
      this.activeTab = 0
    }
  },

  beforeRouteUpdate (to, from, next) {
    this.location = to.params.locationData
    next()
  },

  created () {
    this.location = typeof this.$route.params.locationData === 'undefined' ? this.$store.state.currentLocationData : this.$route.params.locationData
  }
}
</script>
